<template>
  <div>
    <!-- Loading while checking auth -->
    <div
      v-if="!hasLoadedLogin"
      class="layout-container flex justify-center mt-64"
    >
      <LoadingIcon />
    </div>

    <!-- Media bank - documents only if not logged in, full access if logged in -->
    <MediaBankPage v-else mode="b2b" :is-logged-in="isLoggedIn" />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '~/store/user';
import { useGlobalContentStore } from '~/store/globalContent';
import { storeToRefs } from 'pinia';
import LoadingIcon from '~/components/generic/LoadingIcon.vue';
import MediaBankPage from '~/components/media-bank/MediaBankPage.vue';

const userStore = useUserStore();
const globalContentStore = useGlobalContentStore();
const { isLoggedIn, hasLoadedLogin } = storeToRefs(userStore);

// Force B2B mode for this page
globalContentStore.setIsB2b(true);
</script>
